<template>
    <!-- @todo Gérer responsive avec toggeable -->
    <b-navbar toggleable="sm" type="dark" variant="black-light" class="p-0 m-0 w-100">
        <!-- Menu d'accès aux boutons/menus d'actions globales (sur petit écran) -->
        <b-navbar-toggle v-if="checkSmPortrait()" target="nav-collapse" />

        <!-- Logo Dcx -->
        <b-navbar-brand :class="checkSmPortrait() ? 'mr-0' : 'mx-4'">
            <!-- Icone Dcx -->
            <b-img :src="AbsoluteLink('Images/Logo_DCX_Blanc' + (checkSmPortrait() ? '_mobile' : '') + '.png')" class="d-inline-block" />

            <!-- Logo du client -->
            <b-img v-if="currentClientLogo" :src="currentClientLogo" class="d-inline-block ml-3 bg-white" style="max-height: 4vh;" />

            <!-- Nom de la base de données -->
            <b-badge variant="dark" pill :class="$screen.breakpoint === 'xs' && envName() !== 'Production' ? 'mx-1' : 'ml-2 mr-3'">{{ currentClientName }}</b-badge>

            <!-- Affichage de l'environnement en cours (seulement si pas environnement de production) -->
            <b-badge v-if="envName() !== 'Production'" variant="danger" pill :class="$screen.breakpoint === 'xs' ? 'mx-0' : 'ml-2 mr-3'">
                {{ $t('Version') }} {{ version() }} '{{ title().toLowerCase() }}'
            </b-badge>

            <!-- Langue de l'utilisateur -->
            <b-badge v-if="envName() !== 'Production'">{{ $t('Language') }} : {{ $i18n.locale }}</b-badge>
        </b-navbar-brand>

        <!-- Bouton bascule entre : tableau de bord principal / cartographie / espace de travail -->
        <b-navbar-nav :class="['ml-auto flex-grow-0', {'px-3': !(this.$screen.breakpoint === 'xs' || this.$screen.breakpoint === 'sm'), 'pr-0': checkSmPortrait() }]">
            <b-nav-item link-classes="px-0">
                <b-button-group class="btn-dark rounded-pill">
                    <!-- Affichage du tableau de bord principal -->
                    <b-button v-if="masterAction('MainDashboard')" @click="$store.dispatch('ToggleMode', workingModeEnum.MainDashboard)" v-b-tooltip.hover :title="$t('MainDashboard')" :variant="WorkingMode === workingModeEnum.MainDashboard ? 'primary' : 'dark'" pill class="border-dark px-2">
                        <b-icon icon="speedometer" />
                    </b-button>
                    <!-- Affichage de la carte -->
                    <b-button v-if="masterAction('Map')" @click="$store.dispatch('CartoMod/ToggleIsVisible'); $store.dispatch('ToggleMode', workingModeEnum.Map)" v-b-tooltip.hover :title="$t('Map')" :variant="mapIsVisible ? 'tertiary': 'dark'" pill class="border-dark px-2">
                        <b-icon icon="map" />
                    </b-button>
                    <!-- Affichage de l'espace de travail -->
                    <b-button v-if="masterAction('Workbench')" @click="$store.dispatch('ToggleMode', workingModeEnum.Workbench)" v-b-tooltip.hover :title="$t('Workbench')" :variant="WorkingMode === workingModeEnum.Workbench ? 'secondary' : 'dark'" pill class="border-dark px-2">
                        <b-icon icon="eye" />
                    </b-button>
                </b-button-group>
            </b-nav-item>
        </b-navbar-nav>

        <!-- Boutons/menus d'actions globales (sur petit écran) -->
        <template v-if="checkSmPortrait()">
            <!-- Boutons à afficher sur petits écrans en portrait -->
            <b-navbar-nav class="flex-grow-0 px-1">
                <b-nav-item>
                    <!-- Bouton de passage en plein écran pour petits écrans-->
                    <b-button v-if="$screen.breakpoint === 'xs'" @click="toggle" v-b-tooltip.hover :title="fullscreen ? $t('LeaveFullScreen') : $t('FullScreen')" variant="dark" size="sm" class="btn-circle">
                        <b-icon-fullscreen-exit v-if="fullscreen" />
                        <b-icon-fullscreen v-else />
                    </b-button>
                </b-nav-item>
            </b-navbar-nav>

            <b-collapse id="nav-collapse" is-nav class="flex-grow-0">
                <b-navbar-nav>
                    <!-- Administration non disponible sur mobile -->
                    <!-- Système de partages d'élements -->
                    <b-nav-item v-if="masterAction('Share')" @click="shareVisible = true">
                        <b-row class="px-0 mx-0">
                            <b-col cols="2" class="text-center">
                                <b-icon icon="share-fill" />
                            </b-col>
                            <b-col cols="auto" class="px-1 m-0">
                                {{ $t('Share') }}... <!-- Partager... -->
                            </b-col>
                        </b-row>
                    </b-nav-item>

                    <!-- Système d'alertes -->
                    <b-nav-item v-if="masterAction('Alert')" @click="$store.dispatch('ToggleMode', workingModeEnum.Alert)" :pressed.sync="localAlertSystemModeSync">
                        <b-row class="px-0 mx-0">
                            <b-col cols="2" class="text-center">
                                <b-icon icon="exclamation-triangle" />
                            </b-col>
                            <b-col cols="auto" class="px-1 m-0">
                                {{ $t('AlertSystem') }} <!-- Système d'alertes -->
                            </b-col>
                        </b-row>
                    </b-nav-item>

                    <!-- Informations personelles -->
                    <b-nav-item @click="personnalDataVisible = true">
                        <b-row class="px-0 mx-0">
                            <b-col cols="2" class="text-center">
                                <b-icon icon="person" />
                            </b-col>
                            <b-col cols="auto" class="px-1 m-0">
                                {{ $t('PersonalInfo') }} <!--Informations personnelles -->
                            </b-col>
                        </b-row>
                    </b-nav-item>

                    <!-- Aide -->
                    <b-nav-item v-if="masterAction('Help')" target="_blank" :href="WIKI_URL">
                        <b-row class="px-0 mx-0">
                            <b-col cols="2" class="text-center">
                                <b-icon icon="question-lg" />
                            </b-col>
                            <b-col cols="auto" class="px-1 m-0">
                                {{ $t('Help') }} <!-- Aide -->
                            </b-col>
                        </b-row>
                    </b-nav-item>

                    <!-- Déconnexion -->
                    <b-nav-item @click="logOut()">
                        <b-row class="px-0 mx-0">
                            <b-col cols="2" class="text-center">
                                <font-awesome-icon icon="arrow-right-from-bracket" />
                            </b-col>
                            <b-col cols="auto" class="px-1">
                                {{ $t('LogOut') }} <!-- Déconnexion -->
                            </b-col>
                        </b-row>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </template>

        <!-- Boutons/menus d'actions globales sur grand écran ou petit écran en paysage -->
        <b-navbar-nav v-else class="flex-grow-0 px-3">
            <!-- Bouton de Téléchargement -->
            <b-nav-item v-if="downloadList && downloadList.length > 0" :link-classes="['px-1', { 'py-1': checkSmLandscape() }]">
                <b-dropdown v-b-tooltip.hover :title="$t('Downloads')" ref="dlDrop" show="true" variant="dark" size="sm" :toggle-class="['btn-circle text-decoration-none d-flex align-items-center justify-content-center']" right no-caret>
                    <template #button-content>
                        <b-iconstack font-scale="1">
                            <!-- Animation de fin -->
                            <b-icon v-if="animation" animation="throb" stacked scale="1.8" icon="download" class="text-success" />
                            <!-- Flèche verte pendant le spinner -->
                            <b-icon v-else-if="downloadList.filter(u => u.State === downloadStateEnum.InProgress).length > 0 && !animation" stacked icon="download" class="text-secondary" />
                            <!-- Flèche normale -->
                            <b-icon v-else stacked icon="download" />
                            <!-- Spinner -->
                            <b-icon v-if="downloadList.filter(u => u.State === downloadStateEnum.InProgress).length > 0 && !animation" stacked icon="arrow-clockwise" scale="1.6" animation="spin" class="text-secondary" />
                        </b-iconstack>
                    </template>
                    <!-- Liste des téléchargements -->
                    <b-dropdown-item v-for="download in downloadList.filter(u => u.State != downloadStateEnum.InProgress).sort((a, b) => b.Index - a.Index)" :key="download.Index" @click="generateDownload(download)" class="p-1 border" :class="download.State === downloadStateEnum.Downloaded ? '' : 'bg-gray'">
                        <font-awesome-icon v-if="download.State != downloadStateEnum.Error" :icon="['fas', getExtensionIcon(download.Type)]" class="text-left" />
                        <b-icon v-if="download.State === downloadStateEnum.Error" icon="x-circle" scale="0.9" variant="danger" />
                        {{ download.Name }}
                    </b-dropdown-item>
                </b-dropdown>
            </b-nav-item>
            <!-- Partage d'éléments -->
            <b-nav-item v-if="masterAction('Share')" :link-classes="['px-1', { 'py-1': checkSmLandscape() }]">
                <b-avatar variant="secondary" button badge-top
                    badge-variant="info" badge-class="p-0" size="2rem"
                >
                    <template #default>
                        <b-button v-b-tooltip.hover :title="$t('Share') + '...'" @click="shareVisible= true" :pressed="shareVisible" variant="dark" size="sm" class="btn-circle d-flex align-items-center justify-content-center">
                            <b-icon-share-fill />
                        </b-button>
                    </template>
                    <template #badge v-if="shareComponentList.filter(s => s.Share).length > 0">
                        {{ shareComponentList.filter(s => s.Share).length }}
                    </template>
                </b-avatar>
            </b-nav-item>
            <!-- Administration -->
            <b-nav-item v-if="!($screen.breakpoint === 'xs' || $screen.breakpoint === 'sm') && masterAction('Administration')" :link-classes="['px-1', { 'py-1': checkSmLandscape() }]">
                <b-button v-b-tooltip.hover :title="$t('Administration')" @click="$store.dispatch('ToggleMode', workingModeEnum.Administration)" :pressed.sync="localAdminModeSync" :variant="WorkingMode === workingModeEnum.Administration ? 'quartary' : 'dark'" size="sm" :class="['btn-circle d-flex align-items-center justify-content-center', {'disabled': ($screen.breakpoint === 'xs' || $screen.breakpoint === 'sm')}]">
                    <b-icon icon="tools" scale="0.9" />
                </b-button>
            </b-nav-item>
            <!-- Système d'alertes -->
            <b-nav-item v-if="masterAction('Alert')" :link-classes="['px-1', { 'py-1': checkSmLandscape() }]">
                <b-button v-b-tooltip.hover :title="$t('AlertSystem')" @click="$store.dispatch('ToggleMode', workingModeEnum.Alert)" :pressed.sync="localAlertSystemModeSync" variant="dark" size="sm" class="btn-circle d-flex align-items-center justify-content-center">
                    <b-icon icon="exclamation-triangle-fill" scale="0.9" />
                </b-button>
            </b-nav-item>

            <!-- #region Système de notifications -->

            <b-nav-item-dropdown right no-caret menu-class="dropdown-menu-lg-end">
                <template #button-content>
                    <b-avatar variant="secondary" button badge-top
                        badge-variant="info" badge-class="p-0" size="2rem"
                        :disabled="false">
                        <template #default>
                            <!-- Bouton cloche -->
                            <b-button variant="dark" size="sm" class="btn-circle d-flex align-items-center justify-content-center">
                                <b-icon-bell-fill />
                            </b-button>
                        </template>
                        <template #badge v-if="unreadNotificationsCount() > 0">
                            {{ unreadNotificationsCount() }}
                        </template>
                    </b-avatar>
                </template>

                <LastNotification :NewsNotifications="NewsNotifications" :UnreadCount="unreadNotificationsCount()" />               
            </b-nav-item-dropdown>

            <!-- #endregion Système de notifications -->

            <!-- Informations personnelles / déconnexion -->
            <b-nav-item-dropdown right :toggle-class="['px-1', { 'py-1': checkSmLandscape() }]">
                <template #button-content>
                    <b-button :pressed="personnalDataVisible" variant="dark" size="sm" class="btn-circle">
                        <b-icon icon="person" scale="0.9" />
                    </b-button>
                </template>
                <!-- Informations personnelles -->
                <b-dropdown-item @click="personnalDataVisible = true">{{ $t('PersonalInfo') }}...</b-dropdown-item>
                <!-- Changement de bases -->
                <b-dropdown-item v-if="isUserSupervisor" @click="changeClientbaseVisible = true">{{ $t('DatabaseChange') }}</b-dropdown-item><!-- Changer de base de données... -->
                <!-- Changement d'utilisateur -->
                <b-dropdown-item v-if="!isUserSupervisor && profileId == 1" @click="changeUserBaseVisible = true">Changement d'utilisateur...</b-dropdown-item>
                <!-- Aide -->
                <b-dropdown-item v-if="masterAction('Help')" target="_blank" :href="WIKI_URL"><!--<b-icon icon="question" /> -->{{ $t('Help') }}</b-dropdown-item> <!-- Aide -->
                <!-- Déconnexion -->
                <b-dropdown-item @click="logOut()">{{ $t('LogOut') }}</b-dropdown-item> <!-- Déconnexion -->
            </b-nav-item-dropdown>
            <!-- Bouton de passage en plein écran pour petits écrans-->
            <b-nav-item v-if="this.$screen.breakpoint === 'xs' || this.$screen.breakpoint === 'sm' || this.$screen.breakpoint === 'md'" :link-classes="['px-1', { 'py-1': checkSmLandscape() }]">
                <b-button @click="toggle" v-b-tooltip.hover :title="fullscreen ? $t('ExitFullscreen') : $t('Fullscreen')" variant="dark" size="sm" class="btn-circle">
                    <b-icon-fullscreen-exit v-if="fullscreen" />
                    <b-icon-fullscreen v-else />
                </b-button>
            </b-nav-item>
        </b-navbar-nav>

        <!-- Composant SearchNews au click de showAllNotifications -->
        <SearchNews v-if="isSearchNewsVisible" :notifications="NewsNotifications" :visible="isSearchNewsVisible" />

        <!-- Fenêtre modale Informations Personnelles-->
        <PersonnalInfo v-if="personnalDataVisible" :Visible.sync="personnalDataVisible" />

        <!-- Fenêtre modale Liste de base de données -->
        <ConnexionList v-if="changeClientbaseVisible" :Visible.sync="changeClientbaseVisible" :ChangeBase="true" :Language="$store.getters['SessionStore/GetLanguage']" />

        <ClientList v-if="changeUserBaseVisible" :Visible.sync="changeUserBaseVisible" :ChangeBase="true" :ConnectionId="currentClientId" />

        <!-- Fenêtre modale Partage de composant -->
        <Share v-if="shareVisible" :Visible.sync="shareVisible" Variant="primary" :Action="masterAction('Share')" />

    </b-navbar>
</template>

<script lang="ts">
    import { WIKI_URL } from '@/App.settings';
    import { Component, Prop, Watch } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';
    import { mixins } from 'vue-class-component';
    import { ConnectionUtils, EnvUtils, LinkUtils, ScreenUtils, IconsUtils } from "@/components/commons/Utils";
    import WorkingModeEnum from '@/enums/WorkingModeEnum';
    import PersonnalInfo from './Header/PersonnalInfo.vue';
    import Share from '@/components/MasterPage/Header/Share.vue';
    import Download from '@/types/Download';
    import DownloadStateEnum from '@/enums/DownloadStateEnum';
    import ConnexionList from '@/components/commons/ConnexionList.vue';
    import ClientList from '../commons/ClientList.vue';
    import locales from './locales/Header.json';
    import NewsNotification from '@/types/NewsNotification';
    import SearchNews from '@/components/commons/News/SearchNews.vue';
    import LastNotification from './Header/Notifications/LastNotifications.vue';
    import ShareItem from '@/types/ShareItem';
    /** En-tête du site contenant les boutons de navigation généraux : administration, déconnexion, .... */
    @Component({
        components: {
            PersonnalInfo,
            Share,
            ConnexionList,
            ClientList,
            SearchNews,
            LastNotification
        },
        i18n: { messages: locales }
    })
    export default class Header extends mixins(LinkUtils, ScreenUtils, ConnectionUtils, EnvUtils, IconsUtils) {
        /** Pour pouvoir utiliser ces variables dans la section template */
        private workingModeEnum = WorkingModeEnum;
        private downloadStateEnum = DownloadStateEnum;
        private WIKI_URL = WIKI_URL;

        private localAdminModeSync: boolean = false;
        private localAlertSystemModeSync: boolean = false;
        private personnalDataVisible: boolean = false;
        private shareVisible: boolean = false;
        /** Permet d'afficher la fenêtre de changement de bases */
        private changeClientbaseVisible: boolean = false;
        /** Permet d'afficher la fenêtre de changement d'utilisateurs */
        private changeUserBaseVisible: boolean = false;
        /** Variable de toggle fullscreen */
        private fullscreen: boolean = false;

        /** Permet de récupérer les partages (Tableau de bord, Périmètre, Masque) */
        private get shareComponentList(): ShareItem[] {
            console.debug("get shareComponentList()");

            return (this.$store.getters['GetSharableItems'] as ShareItem[]) || [];
        }

        /** Getter pour l'état de visibilité de la modale */
        @Getter('NotificationsStore/GetIsSearchNewsVisible')
        private isSearchNewsVisible!: boolean;

        /** Nom de la base de données courante */
        @Getter('SessionStore/GetCurrentClientName')
        private currentClientName!: string;

        /** Nom de la base de données courante */
        @Getter('SessionStore/GetCurrentClientId')
        private currentClientId!: string;

        /** Logo du client actuellement connecté */
        @Getter('SessionStore/GetCurrentClientLogo')
        private currentClientLogo!: string;

        /** Information si utilisateur superviseur */
        @Getter('SessionStore/GetUserIsSupervisor')
        private isUserSupervisor: boolean;

        /** Inforamtion de l'identifiant du profil de l'utilisateur courant */
        @Getter('SessionStore/GetProfileId')
        private profileId: number;

        /** Indique si la carte est affiché ou non */
        @Getter('CartoMod/GetIsVisible')
        private mapIsVisible!: boolean;

        /** Récupère la liste des Téléchargement */
        @Getter('DownloadingStore/GetDownloadList')
        private downloadList!: Download[];

        /** Récupère la liste des Téléchargement */
        @Getter('DownloadingStore/GetAnimationState')
        private animation!: boolean;
        
        /** Verification si des notifications n'ont pas été lues */
        private unreadNotificationsCount(): number {
            return this.NewsNotifications.filter((notification: NewsNotification) => notification.IsRead == false).length;
        }
       
        /** Mode de travail en cours */
        @Prop()
        public WorkingMode!: WorkingModeEnum;

        @Prop()
        public NewsNotifications!: NewsNotification[];
        

        /** Méthode pour passer en fullScreen */
        private toggle() {
            this.$fullscreen.toggle();
            this.fullscreen = !this.$fullscreen.isFullscreen;
        }

        /** Gestion mode passage d'un mode à l'autre
         * @see WorkingModeEnum Enumération des différents mode de travail proposé par Dcx
         */
        @Watch('WorkingMode')
        private updateAdminMode() {
            if (this.WorkingMode !== WorkingModeEnum.Administration)
                this.localAdminModeSync = false;

            if (this.WorkingMode !== WorkingModeEnum.Alert)
                this.localAlertSystemModeSync = false;
        }

        /** Obtient les droits associés à une fonction */
        @Getter('GetMasterAction')
        private masterAction!: (featureName: string) => string | undefined;

        @Watch('animation', { immediate: true })
        private async openDropDown() {
            if (this.animation && this.downloadList[this.downloadList.length - 1].Direct === false) {
                (this.$refs.dlDrop as HTMLFormElement).visible = true;
            }
        }

        private generateDownload(download: Download) {
            if (download.State != DownloadStateEnum.Error) {
                download.State = DownloadStateEnum.Downloaded;
                this.GenerateFile(download.Data, download.Name);
            } else {
                this.$bvToast.toast(this.$t('CorruptedFile').toString(), { // "Le fichier est corrompu. Veuillez contacter votre administrateur."
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }
        }
    }
</script>

<style scoped>
</style>